import { closeDrawer } from "./toggleDrawer";
(function () {
  $(".page-navigation-mega-menu").accessibleMegaMenu();

  // Add delay and overlay for desktop main menu hover

  var hoverTimerItem;
  $(".page-navigation-mega-menu .level1.parent")
    .mouseenter(function () {
      var that = $(this);
      clearTimeout(hoverTimerItem);
      hoverTimerItem = setTimeout(function () {
        $(that).addClass("delay-hover");
        $("body").addClass("toggled-drawer-offset-overlay");
      }, 500);
    })
    .mouseleave(function () {
      var that = $(this);
      clearTimeout(hoverTimerItem);
      hoverTimerItem = setTimeout(function () {
        that.removeClass("delay-hover");
        $("body").removeClass("toggled-drawer-offset-overlay");
      }, 500);
    });

  var hoverTimer;
  $(".accessible-megamenu")
    .mouseenter(function () {
      var that = this;
      hoverTimer = setTimeout(function () {
        $(that).addClass("hovered");
        if ($("body.drawer-open").length) {
          closeDrawer($("[data-drawer-toggle='top-search-module']"), $("body"));
        }
      }, 500);
    })
    .mouseleave(function () {
      clearTimeout(hoverTimer);
      $(this).removeClass("hovered");
    });

  var focusTimer;
  $(".accessible-megamenu")
    .focusin(function () {
      clearTimeout(focusTimer);
      if ($("body.drawer-open").length) {
        closeDrawer($("[data-drawer-toggle='top-search-module']"), $("body"));
      }
      $(".accessible-megamenu").addClass("focused");
      if ($(".accessible-megamenu .accessible-megamenu-panel.open").length) {
        $("body").addClass("toggled-drawer-offset-overlay");
      } else {
        $("body").removeClass("toggled-drawer-offset-overlay");
      }
    })
    .focusout(function () {
      focusTimer = setTimeout(function () {
        $(".accessible-megamenu").removeClass("focused");
        $("body").removeClass("toggled-drawer-offset-overlay");
      }, 100);
    });

  $(".page-navigation-menu .level1.parent").on("keydown", function (e) {
    if (e.which === 13) {
      $("body").addClass("toggled-drawer-offset-overlay");
    }
  });
})();
